/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

const appswebroots = (window._oc_appswebroots !== undefined) ? window._oc_appswebroots : false

export default appswebroots
